module.exports = __webpack_public_path__ + "static/media/ccad3.9323f920.png";